(function () {
    'use strict';

    // @ngInject
    function ReportsAnalyticsControllerCtor(
        $scope, $injector, AppConfigService, ReportsManager, CompaniesManager, UsersManager, DeviceService, _, JsSlicklightboxService,
        UiPersistenceService, PopupMessageService, moment, OnboardingService, $translate, ModalService, $timeout,
        $sce, ngToast, AnalyticsService, EventService, Enums, ToastService, $state, $stateParams) {

        var self = this;
        this.destroyed = false;


        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ReportsAnalyticsController';
        this.moment = moment;
        this.OnboardingService = OnboardingService;
        this.$translate = $translate;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.ReportsManager = ReportsManager;

        this.JsSlicklightboxService = JsSlicklightboxService;
        this.galleryInitialized = false;
        this.lightboxContainer = "#how-it-looks-reports";
        this.howLeadSourceLooksImages = [
            "//res.cloudinary.com/honeybook/image/upload/f_auto,q_auto,fl_lossy/v1551102667/empty_states/reports/gallery/empty-modal-ls-reports-1_2x.png",
            "//res.cloudinary.com/honeybook/image/upload/f_auto,q_auto,fl_lossy/v1551102667/empty_states/reports/gallery/empty-modal-ls-reports-2_2x.png"
        ];

        this.PopupMessageService = PopupMessageService;
        this.UiPersistenceService = UiPersistenceService;
        this.ModalService = ModalService;
        this.$timeout = $timeout;
        this.$sce = $sce;
        this.ngToast = ngToast;
        this.AnalyticsService = AnalyticsService;
        this.Enums = Enums;
        this.ToastService = ToastService;
        this.CompaniesManager = CompaniesManager;
        this.DeviceService = DeviceService;
        this.isMobile = this.DeviceService.nxSmallBreakpoint();
        this._ = _;
        this.shouldHideContactFormProTip = false;

        this.company = CompaniesManager.getCurrCompany();
        this.currUser = UsersManager.getCurrUser();
        this._initCompanyData();

        this.source = "reports";
        this.proTipBoldText = 'PRO TIP: ';
        this.proTipText = 'Connect the Contact Form with your website to';
        this.proTipLink = 'capture your leads';
        this.hasLeadsSourceData = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.showLeadsReportIntro, {hide: false}).hide;
        this.tagsAnalyticsArgs = {source: "lead_source_modal", secondary_source: this.source};

        if (!this.company.wasFullyFetched()) {
            this.registerOnce(this.company, 'success', this._initCompanyData.bind(this));
        }
        var reportState = AppConfigService.reportsState();

        this.loadingReports = false;
        this.loadingSummary = false;
        this.downloadCsvTitle = ''

        // after changing the ui persistency we want to move old values to new
        this.reportsSummary = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.reportsSummary);
        if (this.reportsSummary && (!this.reportsSummary.startDate || !this.reportsSummary.endDate)) {
            this.reportsSummary.startDate = this.reportsSummary.summaryStartDate;
            this.reportsSummary.endDate = this.reportsSummary.summaryEndDate;
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.reportsSummary, this.reportsSummary);
        }

        this.reportsLeads = {};
        this.reportsSummary = this.reportsSummary || {};

        if(!reportState.analytics){

            reportState.analytics = {};
            this.analytics = reportState.analytics;

            this.loadingReports = true;
            ReportsManager.getReportsAnalytics(this.userId).then(
                function success(resp){
                    // when we move from reports tab before loading was done, this callback is still being called but the directive scope no longer exists
                    if (!self.destroyed){
                        self.loadingReports = false;
                        angular.copy(resp.data, reportState.analytics);
                        self.initialize(true);
                    }
                },

                function error(resp){
                    self.loadingReports = false;
                    if(resp && resp.data && resp.data.error_message){
                        self.lastError = resp.data.error_message;
                    } else if (resp && resp.data){
                        self.lastError = JSON.stringify(resp.data);
                    } else {
                        self.lastError = 'REPORTS.ERRORS._UNKOWN_ERROR_';
                    }

                    self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.error, self.lastError);
                }
            );
        }else{
            this.analytics = reportState.analytics;
            this.initialize();
        }

        self.$scope.$on('$destroy', function () {
          self.destroyed = true;
        });

        this.getSummaryReport = function getSummaryReport() {
            this.loadingSummary = true;
            var startDate = moment(this.reportsSummary.startDate, 'MMM DD, YYYY').format('DD/MM/YYYY');
            var endDate = moment(this.reportsSummary.endDate, 'MMM DD, YYYY').format('DD/MM/YYYY');

            ReportsManager.getEventsReportTotals(null, startDate, endDate).then(function success(resp) {
                this.eventsReportPaidPayments = resp.data.paid;
                this.eventsReportOutstandingPayments = resp.data.not_paid;
                this.eventsReportRefundedPayments = resp.data.refunded;
                this.eventsReporTotalValue = resp.data.total;
                this.eventsReportEventsCount = resp.data.event_count;
                this.loadingSummary = false;
            }.bind(this));
        }.bind(this);

        this.$scope.$on("$destroy", function() {
            this.ngToast.dismiss(this.toastLeadSource);
        }.bind(this));

        this.leadSourceCharts = {
            distribution: {
                tabText: this.$translate.instant("LEADSOURCE.CHARTS.DISTRIBUTION._NAME_"),
                data: '',
                key: 'distribution',
                getTitle: () => this.$translate.instant("LEADSOURCE.CHARTS.DISTRIBUTION._TITLE_", {actual_dates: this.leadsStartDateAmericanFormat + " - " + this.leadsEndDateAmericanFormat }),
                onClick: () => { this.currLeadSourceChart = this.leadSourceCharts.distribution; },
                emptyStateImage : '//res.cloudinary.com/honeybook/image/upload/v1551964002/empty_states/reports/empty-distribution-chart.svg',
            },
            leadsValue: {
                tabText: this.$translate.instant("LEADSOURCE.CHARTS.LEADS_VALUE._NAME_"),
                data: '',
                key: 'leadsValue',
                getTitle: () => this.$translate.instant("LEADSOURCE.CHARTS.LEADS_VALUE._TITLE_", {actual_dates: this.leadsStartDateAmericanFormat + " - " + this.leadsEndDateAmericanFormat }),
                onClick: () => { this.currLeadSourceChart = this.leadSourceCharts.leadsValue; },
                emptyStateImage: '//res.cloudinary.com/honeybook/image/upload/v1551964002/empty_states/reports/empty-value-chart.svg',
            },
            conversionRate: {
                tabText: this.$translate.instant("LEADSOURCE.CHARTS.CONVERSION_RATE._NAME_"),
                data: '',
                key: 'conversionRate',
                getTitle: () => this.$translate.instant("LEADSOURCE.CHARTS.CONVERSION_RATE._TITLE_", {actual_dates: this.leadsStartDateAmericanFormat + " - " + this.leadsEndDateAmericanFormat }),
                onClick: () => { this.currLeadSourceChart = this.leadSourceCharts.conversionRate; },
                emptyStateImage: '//res.cloudinary.com/honeybook/image/upload/v1551964002/empty_states/reports/empty-coversion-chart.svg',
            },
            timeToBook: {
                tabText: this.$translate.instant("LEADSOURCE.CHARTS.TIME_TO_BOOK._NAME_"),
                data: '',
                key: 'timeToBook',
                getTitle: () => this.$translate.instant("LEADSOURCE.CHARTS.TIME_TO_BOOK._TITLE_", {actual_dates: this.leadsStartDateAmericanFormat + " - " + this.leadsEndDateAmericanFormat }),
                onClick: () => { this.currLeadSourceChart = this.leadSourceCharts.timeToBook; },
                emptyStateImage: '//res.cloudinary.com/honeybook/image/upload/v1551964002/empty_states/reports/empty-bookTime-chart.svg',
            }
        };

        this.currLeadSourceChart = this.leadSourceCharts.distribution;

    }

    Controllers.ReportsAnalyticsController = Class(Controllers.BaseController, {

        constructor: ReportsAnalyticsControllerCtor,

        onLeadSourceTabSelect : function onLeadSourceTabSelect(selectedTab) {
            if (selectedTab.onClick && angular.isFunction(selectedTab.onClick)) {
                selectedTab.onClick();
            }
        },

        _initCompanyData: function _initCompanyData() {
            if (this.company) {
                this.leadSourcesList = this.company.sortedLeadSources();
                this.shouldHideContactFormProTip = (this.company &&
                    this.company.contact_forms &&
                    this.company.contact_forms.length > 0 &&
                    this.company.contact_forms[0].website_views_count &&
                    this.company.contact_forms[0].website_views_count > 0);
            }
        },

        _translaeLeadSourceData: function _translaeLeadSourceData(leadsData) {
            var graphsData = {};

            for (var leadKey in leadsData) {
                if (leadKey && leadsData.hasOwnProperty(leadKey)) {
                    var metricData = leadsData[leadKey];
                    for (var metricKey in metricData) {
                        if (metricData.hasOwnProperty(metricKey)) {
                            graphsData[metricKey] = graphsData[metricKey] || [];
                            var currValue = metricData[metricKey];
                            if (metricKey === 'avg_time_to_booked') {
                                // convert seconds to days
                                currValue = Math.round(currValue / 86400);
                            } else if (metricKey === 'conversion_rate') {
                                currValue = Math.round(currValue * 100);
                            }

                            graphsData[metricKey].push({label: leadKey, value: currValue});
                        }
                    }
                }
            }

            var _leadSourceDistributionData = _.sortBy(graphsData.count, 'value').reverse();
            this.leadSourceCharts.distribution.data = {
                values: _.pluck(_leadSourceDistributionData, 'value'),
                labels: _.pluck(_leadSourceDistributionData, 'label'),
                xAxesLabel: 'Lead sources',
                yAxesLabel: 'Leads (#)',
                hoverBackgroundColor: '#4fe0c0',
                tickSign: '',
            };


            var _leadSourceLeadsValueData = _.sortBy(graphsData.avg_lead_value, 'value').reverse();
            this.leadSourceCharts.leadsValue.data = {
                values: _.pluck(_leadSourceLeadsValueData, 'value'),
                labels: _.pluck(_leadSourceLeadsValueData, 'label'),
                xAxesLabel: 'Lead sources',
                yAxesLabel: 'Value ($)',
                hoverBackgroundColor: '#71e3e3',
                tickSign: '$',
            };

            var _leadSourceConversionRateData = _.sortBy(graphsData.conversion_rate, 'value').reverse();
            this.leadSourceCharts.conversionRate.data = {
                values: _.pluck(_leadSourceConversionRateData, 'value'),
                labels: _.pluck(_leadSourceConversionRateData, 'label'),
                xAxesLabel: 'Lead sources',
                yAxesLabel: 'Conversion rate (%)',
                hoverBackgroundColor: '#6c5ce7',
                yAxesMax: 100,
                tickSign: '%',
            };

            var _leadSourceTimeToBookData = _.sortBy(graphsData.avg_time_to_booked, 'value');
            this.leadSourceCharts.timeToBook.data = {
                values: _.pluck(_leadSourceTimeToBookData, 'value'),
                labels: _.pluck(_leadSourceTimeToBookData, 'label'),
                xAxesLabel: 'Lead sources',
                yAxesLabel: 'Days',
                hoverBackgroundColor: '#bbc6f7',
                tickSign: '',
            };
        },

        getLeadsReport: function getLeadsReport() {
            if (!this.hasLeadsSourceData) {
                return;
            }

            this.loadingLeads = true;
            this.leadsStartDate = this.moment(this.reportsLeads.startDate, 'MMM DD, YYYY').format('DD/MM/YYYY');
            this.leadsEndDate = this.moment(this.reportsLeads.endDate, 'MMM DD, YYYY').format('DD/MM/YYYY');
            this.leadsStartDateAmericanFormat = this.moment(this.reportsLeads.startDate, 'MMM DD, YYYY').format('MM/DD/YYYY');
            this.leadsEndDateAmericanFormat = this.moment(this.reportsLeads.endDate, 'MMM DD, YYYY').format('MM/DD/YYYY');

            this.ReportsManager.getLeadsReport(null, this.leadsStartDate, this.leadsEndDate).then(function success(resp) {
                this._translaeLeadSourceData(resp.data.report);
                this.loadingLeads = false;
                this.downloadCsvTitle = this.$translate.instant('REPORTS.ANALYTICS.SUMMARY._DOWNLOAD_LINK_TOOLTIP_');

            }.bind(this));
        },

        onClickLeadsProTip: function onClickLeadsProTip() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_click_protip);
            this.$state.go(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'contactForm'});
        },

        initialize: function initialize(first_time){
            this.totals = this.analytics['All-Time'];

            if(first_time){
                this.months = this.totals.period_entries.reverse();
            }else{
                this.months = this.totals.period_entries;
            }

            this.years = [];
            for(var key in this.analytics){
                if(key !== 'All-Time'){
                    this.analytics[key].year = key;
                    this.years.push(this.analytics[key]);
                }
            }

            this.setActiveYear();
            if (this.$stateParams.section) {
                this.scrollToSection(this.$stateParams.section);
            }
        },

        setActiveYear: function setActiveYear(index){
            if(typeof index === 'undefined'){
                index = this.years.length - 1;
            }

            this.activeIndex = index;
            this.activeYear = this.years[index];

            this.prevYear = this.years[index - 1];
            this.nextYear = this.years[index + 1];
        },

        moveToPrevYear: function moveToPrevYear() {
            this.setActiveYear(this.activeIndex - 1);
            this.movingToPrevYear = true;
            this.movingToNextYear = false;
        },

        moveToNextYear: function moveToNextYear() {
            this.setActiveYear(this.activeIndex + 1);
            this.movingToNextYear = true;
            this.movingToPrevYear = false;
        },

        summaryStartDateChanged: function(newDate) {
            this.reportsSummary.summaryStartDate = newDate;
            this.summaryDateChanged();
        },

        summaryEndDateChanged: function(newDate) {
            this.reportsSummary.summaryEndDate = newDate;
            this.summaryDateChanged();
        },

        summaryDateChanged: function summaryDateChanged() {
            if (!this.isValidSummaryDates()) {
                this.summaryDateErrorMessage = this.$translate.instant(
                    'REPORTS.ANALYTICS.SUMMARY._DATE_FILTER_ERROR_MESSAGE_');
            } else {
                this.summaryDateErrorMessage = null;

                this.UiPersistenceService.setUiPersistence(
                    this.UiPersistenceService.keys.reportsSummary, this.reportsSummary);

                this.getSummaryReport();
            }
        },

        isValidSummaryDates: function isValidSummaryDates() {
            // End date should not be earlier than start date
            // 3rd party DatePicker plugin accepts and returns a string,
            // therefore we need to convert back into a date in order to compare...
            var start = new Date(this.reportsSummary.summaryStartDate);
            var end = new Date(this.reportsSummary.summaryEndDate);
            return start <= end;
        },

        saveLeadSources: function saveLeadSources(leadSourcesList) {
            return this.CompaniesManager.updateLeadSources(this.company, leadSourcesList, (this.shouldShowLeadSourcesEditedToast()));
        },

        editLeadSources: function editLeadSources() {
            this.dissmissLeadSourceToast();
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source__modal_opened, this.tagsAnalyticsArgs);
            this.ModalService.openEditLeadSourceModal(this.leadSourcesList, this.saveLeadSources.bind(this) , this.tagsAnalyticsArgs)
                .then(function (edited) {
                    if(edited) {
                       if (this.shouldShowLeadSourcesEditedToast()) {
                           this._showLeadSourcesEditedToast();
                       }
                        this.leadSourcesList = this.company.sortedLeadSources();
                        this.getLeadsReport();
                    }
                }.bind(this));
        },

        shouldShowLeadSourcesEditedToast: function shouldShowLeadSourcesEditedToast() {
            return !this.DeviceService.checkIfMobileSize() && this.currUser.isCompanyOwner() && this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.showLeadSourceToast, {show: true}).show;
        },
        _showLeadSourcesEditedToast: function _showLeadSourcesEditedToast() {
                var toastIcon      = '<span class="icon icon-hb-nx-bell"></span>';
                var toastTitle     = this.$translate.instant('LEADSOURCE.TOAST._TITLE_');
                var toastSubTitle  = this.$translate.instant('LEADSOURCE.TOAST._SUB_TITLE_');
                var toastCtaUpdateText = this.$translate.instant('LEADSOURCE.TOAST._UPDATE_NOW_');
                var toastTextIntro    = this.$translate.instant('LEADSOURCE.TOAST._YOU_CAN_');
                var toastTextReview    = this.$translate.instant('LEADSOURCE.TOAST._REVIEW_');

                var dismiss = '<a ng-click="reportsAnalyticsVm.dissmissLeadSourceToast()" class="lead-sources-toast__close"><span class="icon icon-hb-nx-close-16"></span></a>';
                var toastCtaUpdate = '<a class="lead-sources-toast__cta" ng-click="reportsAnalyticsVm.updateContactForm()" >' + toastCtaUpdateText + '</a>';
                var toastCtaReview = '<div>' + toastTextIntro + '<a ng-click="reportsAnalyticsVm.reviewContactForm()" >' + toastTextReview + '</a>' + toastSubTitle + toastCtaUpdate + '</div>';
                var toastContent   = '<div class="lead-sources-toast__content">' +  '<div><strong>' + toastTitle + '</strong>' + toastCtaReview + '</div>';

                this.toastLeadSourceContent   = '<div class="lead-source__toast">' + toastIcon + toastContent + dismiss +'</div>';

                this.toastLeadSource = this.ngToast.create({
                    content: this.$sce.trustAsHtml(this.toastLeadSourceContent),
                    className: 'lead-source_toast alert alert-info',
                    dismissOnTimeout: false,
                    compileContent: this.$scope
                });

                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_toast__shown, {source: "lead_source_modal", secondary_source: this.source});
        },

        reviewContactForm: function reviewContactForm() {
            this.ngToast.dismiss(this.toastLeadSource);
            this.$state.go(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'contactForm'});
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_toast__closed, {source: "lead_source_modal", secondary_source: this.source, contact_form: "review"});
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showLeadSourceToast, {show: false});
        },

        updateContactForm: function updateContactForm() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_toast__closed, {source: "lead_source_modal", secondary_source: this.source, contact_form: "update"});
            this.CompaniesManager.publishContactFormsLeadSource(this.company)
                .then(function success() {
                    this.ngToast.dismiss(this.toastLeadSource);
                    this._showConfirmationSavedContactFormToast();
                    this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showLeadSourceToast, {show: false});
                }.bind(this));
        },

        _showConfirmationSavedContactFormToast: function _showConfirmationSavedContactFormToast() {
            this.$timeout(function () {
                this.ToastService.showSuccess({
                    contentTranslation: 'LEADSOURCE.TOAST._CONFIRMATION_SAVED_',
                    iconCssClass: 'icon icon-hb-nx-check-mark-circle-16',
                    dismissOnTimeout: true,
                    timeout:3000
                });
            }.bind(this), 1000);
        },

        dissmissLeadSourceToast: function dissmissLeadSourceToast() {
            this.ngToast.dismiss(this.toastLeadSource);
        },

        scrollToSection: function scrollToSection(section) {
            this.$timeout(function () {
                var elm = $('#' + section);
                $("html, body").animate({scrollTop: elm.offset().top - 150}, 300);
            }, 1000);
        },

        // lightbox
        onLightboxShown: function onLightboxShown(event){
            if (event.container === this.lightboxContainer) {
                this.AnalyticsService.track(this, 'empty_state-reports--how_it_looks',{page: 'reports', action: 'opened'});
            }
        },

        onLightboxHidden: function onLightboxHidden(event){
            if (event.container === this.lightboxContainer) {
                this.AnalyticsService.track(this, 'empty_state-reports--how_it_looks',{stage: 'reports', action: 'closed'});
            }
        },

        onLightboxImageChanged: function onLightboxImageChanged(event){
            if (event.container === this.lightboxContainer) {
                this.AnalyticsService.track(this, 'empty_state-reports--how_it_looks',{stage: 'reports', action: 'image_changed'});
            }

        },

        dismissEmptyState: function dismissEmptyState(source) {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_click_dismiss_intro, {source});
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showLeadsReportIntro, {hide: true});
            this.hasLeadsSourceData = true;
            this.getLeadsReport();
        },

        seeHowLeadSourceLooks: function seeHowLeadSourceLooks() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_click_cta_intro);
            if (!this.galleryInitialized){
                this.JsSlicklightboxService.init(this.howLeadSourceLooksImages, this.lightboxContainer);
                this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_HIDDEN, this.onLightboxHidden.bind(this));
                this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_SHOWN, this.onLightboxShown.bind(this));
                this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_IMAGE_CHANGE, this.onLightboxImageChanged.bind(this));
                this.galleryInitialized = true;
            }
            this.JsSlicklightboxService.show();
        }
    });
}());
